// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7r-0";
export var startPickingButton = "_7r-1";